const isDevServerHost =
  typeof window !== "undefined" &&
  window.location.hostname === "dev.fahrzeugverwaltung.rettungsdienstbremen.de";

const redirectUri = isDevServerHost
  ? process.env.REACT_APP_ZITADEL_REDIRECT_URI_DEV ||
    "https://dev.fahrzeugverwaltung.rettungsdienstbremen.de/auth/callback"
  : process.env.REACT_APP_ZITADEL_REDIRECT_URI ||
    `${window.location.origin}/auth/callback`;

const postLogoutRedirectUri = isDevServerHost
  ? process.env.REACT_APP_ZITADEL_POST_LOGOUT_REDIRECT_URI_DEV ||
    "https://dev.fahrzeugverwaltung.rettungsdienstbremen.de"
  : process.env.REACT_APP_ZITADEL_POST_LOGOUT_REDIRECT_URI ||
    window.location.origin;

export const oidcConfig = {
  authority:
    process.env.REACT_APP_ZITADEL_ISSUER ||
    "https://test-v3bmc7.us1.zitadel.cloud",
  client_id: process.env.REACT_APP_ZITADEL_CLIENT_ID || "370853326620851748",
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: "code",
  scope: process.env.REACT_APP_ZITADEL_SCOPE || "openid profile email",
  automaticSilentRenew: true,
  loadUserInfo: true,
};

export const roleClaimCandidates = [
  "urn:zitadel:iam:org:project:roles",
  "roles",
  "role",
];
